import {
  SET_ROADMAP_PROGRESS,
  RESET_ROADMAP_PROGRESS,
} from "../actions/roadmapActions";

const initialState = {
  step: 1,
  answers: {},
//   hasSeenWelcome: false,
};

const roadmapReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_ROADMAP_PROGRESS:
      return {
        ...state,
        step: action.payload.step,
        answers: action.payload.answers,
        // hasSeenWelcome: action.payload.hasSeenWelcome ?? state.hasSeenWelcome,
      };
    case RESET_ROADMAP_PROGRESS:
      return initialState;
    default:
      return state;
  }
};

export default roadmapReducer;
